/*
 * Purpose : generate PDF based in the view screen data for tool sales
 * Author : Soban
 * Copyright (c) - Globalfoundries 
 * 
 * Revision History
 * Version  | Date        | Author  | Description
 * -------------------------------------------------------------------------------------
 * 1.0      | 26-Oct-2021 | Soban   | Initial version
 * 
 */

import { PDFDocument } from 'pdf-lib';
import { jsPDF } from "jspdf";
import {generalConstants} from "../config/constants"
import 'jspdf-autotable'
export const PDFService = (headerData,declaredToolData,nonDeclaredToolData,fileData) =>{
    // Don't forget, that there are CORS-Restrictions. So if you want to run it without a Server in your Browser you need to transform the image to a dataURL
// Use http://dataurl.net/#dataurlmaker
var doc = new jsPDF({
    orientation: 'p',
    unit: 'mm',
    format: 'a4',
    putOnlyUsedFonts:true,
    floatPrecision: 16 // or "smart", default is 16
   });
   
// function createHeaders(keys) {
//   var result = [];
//   for (var i = 0; i < keys.length; i += 1) {              
//     result.push({
//       id: keys[i],
//       name: keys[i],
//       prompt: keys[i],
//       width: 64,
//       align: keys[i]==="Date" ? "right" : "left",
//       padding: 0
//     });
//   }
//   console.log("result header=>",result)
//   return result;
// }

console.log('headerData=>',headerData)
let toolDetails = [...declaredToolData, ...nonDeclaredToolData]
console.log('toolDetails=>',toolDetails)   
console.log('fileData=>',fileData)

//  let rowOneHeaders = createHeaders([
//    "Transaction Type",
//    "Date",
//    "Broker",
//    "Buyer",
//  ]);
let rowOneHeaders = [
"Transaction Type",
"Date",
"Broker",
"Buyer",
];
let rowOneData = 
{
  "Transaction Type": headerData.transactiontype,
  Date: headerData.date,
  Broker: headerData.broker,
  Buyer: headerData.buyer
}
;
let rowTwoHeaders = [
"Total Price ($US)",
"Total NBV ($US)",
"Total Gain/Loss ($US)",
"Status",
];
let rowTwoData = 
  {
    "Total Price ($US)": headerData.total_price,
    "Total NBV ($US)": headerData.total_nbv,
    "Total Gain/Loss ($US)": headerData.total_gain_loss,
    "Status": headerData.status
  }  ;

let rowThreeHeaders =[
  "L3 Fab Approver",
  "L3 Fin Approver"
]
let rowThreeData =  {
  "L3 Fab Approver": headerData.l3_fab_approver,
  "L3 Fin Approver": headerData.l3_fin_approver
}  ;
let rowFourHeaders =[
  "Initiator",
  "Last Updated By",
]
let rowFourData = {
  "Initiator": headerData.initiator,
  "Last Updated By": headerData.last_updated_by
}  ;
let rowFiveHeaders =[
  "Comments",
  "Rejected Reason",
]
let rowFiveData = {
  "Comments": headerData.comment,
  "Rejected Reason": headerData.rejectedreason
}  ;

let toolHeadersOne =[
  "Tool ID",
  "Fab",
  "Location",
  "Vendor/Supplier",
  "Model",
  "Serial No."
]
let toolDataOne = toolDetails.map( elem => [elem.toolid,elem.fab,elem.location,elem.vendor,elem.model,elem.serialnum] )
console.log("toolDataOne=>",toolDataOne)   
  
let toolHeadersTwo =[
  "Tool ID",
  "Offer Price ($US)",
  "NBV ($US)",
  "Original Eqpt Cost ($US)",
  "Offer Price / original Eqpt Cost (%)",
  "Capitalization Date",
  "Sales Type"
]
let toolDataTwo = toolDetails.map( elem => [elem.toolid,elem.price,elem.nbv,elem.org_eqp_price,elem.price_percent,elem.capitalized_date,elem.sales_type] )
console.log("toolDataTwo=>",toolDataTwo)

let toolHeadersThree =[
  "Tool ID",
  "Finance Analysis",
  "Asset Mgmt Status",
  "Remarks",
  "AO confirm no internal Reuse/Part use/Trade-In"
]
let toolDataThree = toolDetails.map( elem => [elem.toolid,elem.fin_analysis,elem.asset_mgt_status,elem.remarks,elem.no_internal_reuse] )
console.log("toolDataThree=>",toolDataThree)
   
   
   
   
   
//doc.setFontSize(40);   
//Main heading
doc.setFont("bold");
doc.text("Tool Sales Transaction Form", 105, 10, {baseline:"alphabetic", align:"center"});
doc.setFont("normal");
doc.setTextColor(84, 91, 100)
doc.setFontSize(9);
doc.text(generalConstants.disclaimer+"\n"+generalConstants.disclaimer2, 10, 15, {baseline:"alphabetic"});

// Transaction Details
doc.setTextColor(251, 135, 52)
doc.setFont("normal");
doc.setFontSize(16);
doc.text("Transaction Details", 10, 25, {baseline:"alphabetic", align:"left"});
doc.setLineWidth(0.5);
doc.setDrawColor(178, 190, 181);
doc.line(10,27,200,27)

doc.setTextColor(23, 162, 184)
doc.setFont("normal");
doc.setFontSize(12);
doc.text("Deal Ref Number:", 10, 32, {baseline:"alphabetic", align:"left"});
doc.text(headerData.deal_ref, 45, 32, {baseline:"alphabetic", align:"left"});

doc.setTextColor(84, 91, 100)
//doc.setFont("normal");
//doc.setFontSize(12);
//doc.table(10, 40, rowOneData, rowOneHeaders, {autoSize: true,headerBackgroundColor:"#fb8734"})   
//doc.table(10, 40, rowOneData, rowOneHeaders, {headerBackgroundColor:"#fb8734"});
//doc.table(10, 70, rowTwoData, rowTwoHeaders, {headerBackgroundColor:"#fb8734"});

doc.autoTable({
  margin: { top: 40, left: 10, bottom: 30 },
  //styles: { fillColor: [255, 0, 0] },
  headStyles: {
    // lineWidth: 1,
    // lineColor: [255, 0, 0]
    fillColor:[251, 135, 52]
  },
  head: [Object.values(rowOneHeaders)],
  body: [Object.values(rowOneData)]
  // [
  //   ['David', 'david@example.com', 'Sweden'],
  //   ['Castille', 'castille@example.com', 'Spain'],
    
  // ],
})

doc.autoTable({
  margin: { top: 70, left: 10, bottom: 30 },
  headStyles: {
    fillColor:[251, 135, 52]
  },
  head: [Object.values(rowTwoHeaders)],
  body: [Object.values(rowTwoData)]
})

doc.autoTable({
  margin: { top: 100, left: 10, bottom: 30 },
  headStyles: {
    fillColor:[251, 135, 52]
  },
  head: [Object.values(rowThreeHeaders)],
  body: [Object.values(rowThreeData)]
})

doc.autoTable({
  margin: { top: 130, left: 10, bottom: 30 },
  headStyles: {
    fillColor:[251, 135, 52]
  },
  head: [Object.values(rowFourHeaders)],
  body: [Object.values(rowFourData)]
})

doc.autoTable({
  margin: { top: 160, left: 10, bottom: 30 },
  headStyles: {
    fillColor:[251, 135, 52]
  },
  head: [Object.values(rowFiveHeaders)],
  body: [Object.values(rowFiveData)]
})

// Transaction Details
doc.setTextColor(251, 135, 52)
doc.setFont("normal");
doc.setFontSize(16);
doc.text("Tool Details", 10, 165, {baseline:"alphabetic", align:"left"});
doc.setLineWidth(0.5);
doc.setDrawColor(178, 190, 181);
doc.line(10,167,200,167)

// doc.autoTable({
//   margin: { top: 210, left: 10, bottom: 0 },
//   headStyles: {
//     fillColor:[251, 135, 52]
//   },
//   head: [Object.values(rowFiveHeaders)],
//   body: [Object.values(rowFiveData)]
// })

//doc.setTextColor(251, 251, 251)
//doc.table(10, 170, toolDataOne, toolHeadersOne, { autoSize: true,headerBackgroundColor:"#fb8734",headerTextColor:"#000000" });

doc.autoTable({
  startY: 170,
  margin: { top: 10, left: 10, bottom: 0 },
  headStyles: {
    fillColor:[251, 135, 52]
  },
  head: [Object.values(toolHeadersOne)],
  body: toolDataOne
})

doc.autoTable({
  //startY: 170,
  margin: { top: 10, left: 10, bottom: 0 },
  headStyles: {
    fillColor:[251, 135, 52]
  },
  head: [Object.values(toolHeadersTwo)],
  body: toolDataTwo
})

doc.autoTable({
  //startY: 170,
  margin: { top: 10, left: 10, bottom: 0 },
  // columnStyles: {
  //     0: {
  //       cellWidth: 30
  //     },
  //     // 1: {
  //     //     columnWidth: 50
  //     // },
  //     // 2: {
  //     //     columnWidth: 35
  //     // },
  //     // 3: {
  //     //     columnWidth: 60
  //     // },
  //     4: {
  //       cellWidth: 25
  //     } 
  // },
  headStyles: {
    fillColor:[251, 135, 52]
  },
  head: [Object.values(toolHeadersThree)],
  body: toolDataThree
})

console.log(fileData.file)
if(fileData.url){
  doc.addPage("a4")
  // Transaction Details
  doc.setTextColor(251, 135, 52)
  doc.setFont("normal");
  doc.setFontSize(16);
  doc.text("SUTL Checklist", 10, 10, {baseline:"alphabetic", align:"left"});
  doc.setLineWidth(0.5);
  doc.setDrawColor(178, 190, 181);
  doc.line(10,12,200,12)

  doc.setTextColor(84, 91, 100)
  //doc.setFont("normal");
  doc.setFontSize(12);
  doc.text("File Description : ", 10, 20, {baseline:"alphabetic", align:"left"});
  doc.text(fileData.description||"", 45, 20, {baseline:"alphabetic", align:"left"});

  doc.addImage(fileData.url, "JPEG", 10, 30, 180, 180);
}

  //doc.addPage("a4","l")
  //doc.table(1, 1, generateData(100), headers, { autoSize: true, headerBackgroundColor:"red",fontSize:"10" });
  //doc.setFont("normal");
//doc.setFontSize(8);
// doc.autoTable({
//   margin: { top: 10, left: 1, bottom: 30 },
//   headStyles: {
//     fillColor:[251, 135, 52]
//   },
//   head: [Object.values(toolHeaders)],
//   body: [Object.values(toolData)]
// })
// doc.setTextColor(251, 135, 52)
// doc.table(1, 1, toolDataOne, toolHeadersOne, { autoSize: true,fontSize:6,headerBackgroundColor:"#fb8734" });

if(fileData.mimetype && fileData.mimetype?.indexOf("pdf")!== -1){
  let arrayB = doc.output('arraybuffer')
  mergeDocs(arrayB,headerData,fileData)
}else{
  doc.save("Tool Sales Form "+headerData.deal_ref+".pdf");
}  
}

const mergeDocs = async (arrayB,headerData,fileData) =>{
  const pdfDoc = await PDFDocument.create();
  const firstDoc = await PDFDocument.load(arrayB);
  const firstPage = await pdfDoc.copyPages(firstDoc, firstDoc.getPageIndices());
  firstPage.forEach((page) => pdfDoc.addPage(page));

  let fileBuffer = await new Response(fileData.file).arrayBuffer()
  const secondDoc = await PDFDocument.load(fileBuffer);
  const secondPage = await pdfDoc.copyPages(secondDoc, secondDoc.getPageIndices());
  secondPage.forEach((page) => pdfDoc.addPage(page));

  const pdfBytes = await pdfDoc.save();
  let file = new Blob([pdfBytes], { type: 'application/pdf' });
  var fileURL = URL.createObjectURL(file);
  //window.open(fileURL);
  //const url = window.URL.createObjectURL(new Blob([new Uint8Array(pdfDoc)]));
  const link = document.createElement('a');
  link.href = fileURL;
  link.setAttribute('download',`Tool Sales Form "${headerData.deal_ref}.pdf`);
  document.body.appendChild(link);
  link.click();                
}


// refs
//https://stackoverflow.com/questions/64856291/issue-while-using-jspdf-autotable-setting-newline-on-d-and-other-characters
